export enum SKELETON_TYPES {
    bingoScheduler = 'bingoScheduler',
    detailed = 'detailed',
    allCategory = 'allCategory',
    inline = 'inline',
    menuItem = 'menuItem',
    inPageMenuItem = 'inPageMenuItem',
    title = 'title',
}

export const MAX_BINGO_SCHEDULER_COUNT = 3;
